import { indexOf } from '@amcharts/amcharts4/.internal/core/utils/Array';
import { Component, HostListener, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Chart } from 'chart.js';
import { SalesService } from '../rest_services/sales.service';
import { VisitService } from '../rest_services/visit.service';
import { Subscription } from 'rxjs';
import { TeamService } from '../rest_services/team.service';
import { ServiceResponse } from '../models/service-response';

// MF-1881 — borne haute du nombre de sujets par visite, imposée côté back aussi.
const MAX_TOPICS = 5;

@Component({
  selector: 'app-customers-goals',
  templateUrl: './customers-goals.component.html',
  styleUrls: ['./customers-goals.component.css']
})
export class CustomersGoalsComponent implements OnInit {

    // advancedSearchForm: FormGroup;
    loading_goals:boolean = false;
    role:any;
    mobile:boolean=false;
    commercial:any=null;
    criticalCustomers:any[]=[];
    warningCustomers:any[]=[];
    successCustomers:any[]=[];
    filterYearForm!:FormGroup;
    currentYear: any="0";
    currentMonth:any;

    searchCriticalTerm: string = '';
    searchWarningTerm: string = '';
    searchSuccessTerm: string = '';
    filteredCriticalCustomers: any[] = [];
    filteredWarningCustomers: any[] = [];
    filteredSuccessCustomers: any[] = [];

    newVisitForm:FormGroup;

    constructor(private fb:FormBuilder, private salesService:SalesService,
        private visitService:VisitService,private teamService: TeamService
    ) {
        this.newVisitForm = this.fb.group({
            commercial: ['', Validators.required],
            actions: [''],
            action_description :[''],
            // MF-1881 — 1 à 5 sujets, obligatoires comme sur les autres écrans de création.
            // Le contrôle n'est pas lié au <select> : il est alimenté par addSelectedTopic().
            topic_uuid: [[] as string[], [Validators.required, Validators.maxLength(MAX_TOPICS)]]
        });
    }

    months: any[] = [];
    financialNumbers:any ={};
    selectedMonth:any;
    
    initializeDefaultMonth(month:any): void {        
        if(month!=null){ // from cover stats CA
            const currentDate = new Date();
            const currentMonth = (month).toString().padStart(2, '0');
            const currentYear = currentDate.getFullYear();
            
            // Initialiser financialNumbers si vide
            if (!this.financialNumbers.year) {
                this.financialNumbers.year = currentYear.toString();
            }        
            // Initialiser selectedMonth avec le mois courant
            this.selectedMonth = `${currentYear}-${currentMonth}`;
            this.currentMonth = `${currentMonth}`;
            this.selectedYear = `${currentYear}`;
            this.CustomersGoals(currentMonth,currentYear);
        }else { // from list customers
            const currentDate = new Date();
            const currentMonth = (currentDate.getMonth() + 1).toString().padStart(2, '0');
            const currentYear = currentDate.getFullYear();
            
            // Initialiser financialNumbers si vide
            if (!this.financialNumbers.year) {
                this.financialNumbers.year = currentYear.toString();
            }        
            // Initialiser selectedMonth avec le mois courant
            this.selectedMonth = `${currentYear}-${currentMonth}`;
            this.currentMonth = `${currentMonth}`;
            this.selectedYear = `${currentYear}`;
            this.CustomersGoals(currentMonth,currentYear);
        }
        
    }
    onMonthChange(selectedValue: string) {
        if (!selectedValue) return;
        
        // Extraire le mois et l'année de la valeur sélectionnée
        const [monthStr, yearStr] = selectedValue.split('-');
        const year = parseInt(monthStr, 10);
        const month = parseInt(yearStr, 10);
        this.currentMonth = `${month}`;
        this.selectedYear = `${year}`;
        // Appeler la fonction avec les paramètres
        this.CustomersGoals(month, year);
    }
    generateMonthsWithCurrent(): void {
        const currentDate = new Date();
        const currentMonth = currentDate.getMonth(); // 0-11
        const currentYear = currentDate.getFullYear();

        // Réinitialiser la liste
        this.months = [];

        // Noms des mois (français)
        const monthNames = [
            'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
            'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'
        ];

        // Noms courts si besoin
        const monthShortNames = [
            'Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Jun',
            'Jul', 'Aoû', 'Sep', 'Oct', 'Nov', 'Déc'
        ];

        // Utiliser l'année sélectionnée ou l'année courante
        const targetYear = this.financialNumbers?.year ? 
            parseInt(this.financialNumbers.year) : currentYear;

        // Générer les 12 mois
        for (let i = 0; i < 12; i++) {
            const monthIndex = i; // 0-11
            const monthNumber = i + 1; // 1-12
            
            // Déterminer si c'est le mois courant
            const isCurrentMonth = (monthIndex === currentMonth && 
                                targetYear === currentYear);
            
            // Différents formats possibles pour la valeur
            const monthValue = monthNumber.toString().padStart(2, '0'); // "01"
            const fullMonthValue = `${targetYear}-${monthValue}`; // "2024-01"
            
            this.months.push({
            value: fullMonthValue, // Vous pouvez utiliser monthValue si besoin
            text: monthNames[monthIndex],
            shortText: monthShortNames[monthIndex],
            monthNumber: monthNumber,
            year: targetYear,
            disabled: false,
            selected: isCurrentMonth,
            isCurrent: isCurrentMonth
            });
        }

        // Optionnel: Si aucun mois n'est sélectionné (par exemple si l'année est différente),
        // sélectionner le premier mois
        const hasSelectedMonth = this.months.some(month => month.selected);
        if (!hasSelectedMonth && this.months.length > 0) {
            this.months[0].selected = true;
        }
    }
    commercialName:any="";
    ngOnInit(): void {
        const urlPart = window.location.href.split('goals/')[1]; //

        // Extraire le mois
        const month = urlPart.split(';')[0]; // "2"

        // Extraire le nom du commercial (sans underscore)
        const cmParam = urlPart.split(';cm=')[1];
        const commercialName = cmParam ? cmParam.replace(/_/g, ' ') : '';

        // Initialiser le mois
        if(month != "current"){
            this.initializeDefaultMonth(Number(month));
        } else {
            this.initializeDefaultMonth(null);
        }

        if(localStorage.getItem("role")!=undefined) {
            this.role =localStorage.getItem("role");
        }else if(sessionStorage.getItem("role")!=undefined){
            this.role =sessionStorage.getItem("role");
        }
        if (window.screen.width < 768) { // 768px portrait
            this.mobile = true;
        }else {
            this.mobile = false;
        }
        this.getAllCustomizedActions();
        this.getTopics(); // MF-1881
        this.getCommercials();
        
        this.generateMonthsWithCurrent();
        var glob=this;
        $('#actionsToSelect').change(function(){ 
        var value = $(this).val();
        var uuid = $("option:selected", this).attr("ud");
        var elt = glob.customizedActions.find(el => el.action_uuid == value);
        var action = {
            action_description : $( "#actionsToSelect option:selected" ).text(),
            action_type : "c",
            action_uuid : uuid
        }
        let index = glob.actionsSelected.findIndex(d => d.action_description == elt.action_label);      
        if(index<0){
            glob.actionsSelected.push(action);
            setTimeout(()=>{
            $('#actionsToSelect').val("")
            }, 500);
        }
        if(glob.actionsSelected.length>0){
            glob.actionNotAssigned = false;
        }else {
            // if($('#datePlanned').val() != "" && $('#datePlanned').val() != null){
            glob.actionNotAssigned = true;
            $("#noActionsSelected").css({"color":"red"});
            // }else {
            //   glob.actionNotAssigned = false;
            // }
        }
        });
    }

    commercialsSubscriptions!: Subscription;
    commercials:any[]=[];
    getCommercials() {
        this.commercialsSubscriptions = this.teamService.getCommercials().subscribe(
          (resp: ServiceResponse) => {
            if(resp.code == "b1f37eec383fcada527079602ac178b3"){
              this.commercials = resp.commercials;
            }
          },
          (err: any) => {
            console.log(err);
          }
        );
    }
    convertirObjets(sourceArray: any[]): any[] {
        return sourceArray.map(source => ({
            name: source.name,
            lastVisit: source.lastVisit,
            objective: source.objective.toString(),
            achieved: source.achieved.toString(),
            avatar: source.avatar?.startsWith('/9j/') ? 
                `${source.avatar}` : 
                source.avatar,
            monthlyData: source.monthlyData,
            commercialName: source.commercialName,
            commercialId: source.commercialId,
            customerId:source.customerId
        }));
    }

    terminatedvisits:any[]=[];
    loading_customers_goals:boolean=false;
    CustomersGoals(month:any, year:any){
        this.loading_customers_goals = true;
        this.salesService.getCustomersGoals(month.toString(),year.toString());
        this.salesService.customersGoalsSubject.subscribe(
        ( data: any ) => {        
            this.criticalCustomers = this.convertirObjets(data.criticalCustomers);
            this.warningCustomers = this.convertirObjets(data.warningCustomers);
            this.successCustomers = this.convertirObjets(data.successCustomers);
            this.filteredCriticalCustomers = [...this.criticalCustomers];
            this.filteredWarningCustomers = [...this.warningCustomers];
            this.filteredSuccessCustomers = [...this.successCustomers];
            this.criticalPagination = data.criticalPagination;
            this.warningPagination = data.warningPagination;
            this.successPagination = data.successPagination;
            this.loading_customers_goals = false;
            // Extraire le nom du commercial (sans underscore)
            const urlPart = window.location.href.split('goals/')[1];
            // Extraire le nom du commercial uniquement si underscore présent
            const cmParam = urlPart.split(';cm=')[1];
            if(cmParam && cmParam.includes('_')) {
                // Pré-remplir le champ de recherche
                const commercialName = cmParam.replace(/_/g, ' '); // "JABRAN Khalid"
                this.searchCriticalTerm = commercialName;
                this.searchWarningTerm = commercialName;
                this.searchSuccessTerm = commercialName;
                this.filterClients('critical'); // déclencher le filtre automatiquement
                this.filterClients('warning'); // déclencher le filtre automatiquement
                this.filterClients('success'); // déclencher le filtre automatiquement
            }
            for(let client of this.criticalCustomers){
                setTimeout(() => {
                    const ctx = (<any>document.getElementById(`chart${this.criticalCustomers.indexOf(client)}`)).getContext('2d');
                    new Chart(ctx, {
                        type: 'bar',
                        data: {
                            labels: ['Jan (MAD HT)', 'Fév (MAD HT)', 'Mar (MAD HT)', 'Avr (MAD HT)', 
                            'Mai (MAD HT)', 'Jun (MAD HT)', 'Jul (MAD HT)', 'Aoû (MAD HT)', 'Sep (MAD HT)', 
                            'Oct (MAD HT)', 'Nov (MAD HT)', 'Déc (MAD HT)'],
                            datasets: [{
                                data: client.monthlyData,
                                backgroundColor: '#4a90e2',
                                borderRadius: 2,
                                borderSkipped: false
                            }]
                        },
                        options: {
                            responsive: true,
                            maintainAspectRatio: false,
                            plugins: {
                                legend: { display: false },
                                tooltip: { enabled: true }
                            },
                            scales: {
                                x: { 
                                    display: false,
                                    grid: { display: false }
                                },
                                y: { 
                                    display: false,
                                    grid: { display: false }
                                }
                            }
                        }
                    });
                }, 100);
            }
            for(let client of this.warningCustomers){
                setTimeout(() => {
                    const ctx = (<any>document.getElementById(`chartwarn${this.warningCustomers.indexOf(client)}`)).getContext('2d');
                    new Chart(ctx, {
                        type: 'bar',
                        data: {
                            labels: ['Jan (MAD HT)', 'Fév (MAD HT)', 'Mar (MAD HT)', 'Avr (MAD HT)', 
                            'Mai (MAD HT)', 'Jun (MAD HT)', 'Jul (MAD HT)', 'Aoû (MAD HT)', 'Sep (MAD HT)', 
                            'Oct (MAD HT)', 'Nov (MAD HT)', 'Déc (MAD HT)'],
                            datasets: [{
                                data: client.monthlyData,
                                backgroundColor: '#4a90e2',
                                borderRadius: 2,
                                borderSkipped: false
                            }]
                        },
                        options: {
                            responsive: true,
                            maintainAspectRatio: false,
                            plugins: {
                                legend: { display: false },
                                tooltip: { enabled: true }
                            },
                            scales: {
                                x: { 
                                    display: false,
                                    grid: { display: false }
                                },
                                y: { 
                                    display: false,
                                    grid: { display: false }
                                }
                            }
                        }
                    });
                }, 100);
            }
            for(let client of this.successCustomers){
                setTimeout(() => {
                    const ctx = (<any>document.getElementById(`chartsuccess${this.successCustomers.indexOf(client)}`)).getContext('2d');
                    new Chart(ctx, {
                        type: 'bar',
                        data: {
                            labels: ['Jan (MAD HT)', 'Fév (MAD HT)', 'Mar (MAD HT)', 'Avr (MAD HT)', 
                            'Mai (MAD HT)', 'Jun (MAD HT)', 'Jul (MAD HT)', 'Aoû (MAD HT)', 'Sep (MAD HT)', 
                            'Oct (MAD HT)', 'Nov (MAD HT)', 'Déc (MAD HT)'],
                            datasets: [{
                                data: client.monthlyData,
                                backgroundColor: '#4a90e2',
                                borderRadius: 2,
                                borderSkipped: false
                            }]
                        },
                        options: {
                            responsive: true,
                            maintainAspectRatio: false,
                            plugins: {
                                legend: { display: false },
                                tooltip: { enabled: true }
                            },
                            scales: {
                                x: { 
                                    display: false,
                                    grid: { display: false }
                                },
                                y: { 
                                    display: false,
                                    grid: { display: false }
                                }
                            }
                        }
                    });
                }, 100);
            }
        })
    }

    /**
     * Charge plus de clients critiques
     */
    // Informations de pagination
    criticalPagination: any = { currentPage: 0, hasMore: false };
    warningPagination: any = { currentPage: 0, hasMore: false };
    successPagination: any = { currentPage: 0, hasMore: false };
    pageSize: number = 5;
    selectedYear: string = '';
    loading_more_critical: boolean = false;
    loading_more_warning: boolean = false;
    loading_more_success: boolean = false;

    loadMoreCritical(): void {
        this.loading_more_critical = true;
        const nextPage = this.criticalPagination.currentPage + 1;

        this.salesService.getCustomersGoals(
            this.currentMonth,
            this.selectedYear,
            this.pageSize,
            nextPage, // Page suivante pour critical
            0, // On ne recharge pas les autres
            0
        );
        this.salesService.customersGoalsSubject.subscribe(
        (response:any) => {
            this.loading_more_critical = false;
            if (response.code === '898f28555b5b058ddf7f80a558eca25a') {
                // Ajouter les nouveaux clients à la liste existante
                this.criticalCustomers = [
                    ...this.criticalCustomers, 
                    ...(response.criticalCustomers || [])
                ];
                this.filteredCriticalCustomers = [...this.criticalCustomers];
                this.criticalPagination = response.criticalPagination;
            }
        },
        (error:any) => {
            this.loading_goals = false;
            console.error('Error loading more critical customers:', error);
        }
        );
    }

    /**
     * Charge plus de clients warning
     */
    loadMoreWarning(): void {
        this.loading_more_warning = true;
        const nextPage = this.warningPagination.currentPage + 1;

        this.salesService.getCustomersGoals(
            this.currentMonth,
            this.selectedYear,
            this.pageSize,
            0,
            nextPage, // Page suivante pour warning
            0
        );
        this.salesService.customersGoalsSubject.subscribe(
        (response:any) => {
            this.loading_more_warning = false;
            if (response.code === '898f28555b5b058ddf7f80a558eca25a') {
                this.warningCustomers = [
                    ...this.warningCustomers, 
                    ...(response.warningCustomers || [])
                ];
                this.filteredWarningCustomers = [...this.warningCustomers];
                this.warningPagination = response.warningPagination;
            }
        },
        (error:any) => {
            this.loading_more_warning = false;
            console.error('Error loading more warning customers:', error);
        }
        );
    }

    /**
     * Charge plus de clients success
     */
    loadMoreSuccess(): void {
        this.loading_more_success = true;
        const nextPage = this.successPagination.currentPage + 1;

        this.salesService.getCustomersGoals(
            this.currentMonth,
            this.selectedYear,
            this.pageSize,
            0,
            0,
            nextPage // Page suivante pour success
        );
        this.salesService.customersGoalsSubject.subscribe(
        (response:any) => {
            this.loading_more_success = false;
            if (response.code === '898f28555b5b058ddf7f80a558eca25a') {
                this.successCustomers = [
                    ...this.successCustomers, 
                    ...(response.successCustomers || [])
                ];
                this.filteredSuccessCustomers = [...this.successCustomers];
                this.successPagination = response.successPagination;
            }
        },
        (error:any) => {
            this.loading_more_success = false;
            console.error('Error loading more success customers:', error);
        }
        );
    }

    filterClients(fieldSearch:any) {        
        if(fieldSearch=="critical"){
            if (!this.searchCriticalTerm || this.searchCriticalTerm.trim() === '') {
                // Si le champ est vide, afficher tous les clients
                this.filteredCriticalCustomers = [...this.criticalCustomers];
                return;
            }
            const searchLower = this.searchCriticalTerm.toLowerCase().trim();
            this.filteredCriticalCustomers = this.criticalCustomers.filter(client => {
                // Recherche dans tous les champs textuels
                const searchableText = 
                `${client.name} ${client.lastVisit} ${client.objective} ${client.achieved} ${client.commercialName}`.toLowerCase();
                
                return searchableText.includes(searchLower);
            });
        }else if(fieldSearch=="warning"){
            if (!this.searchWarningTerm || this.searchWarningTerm.trim() === '') {
                // Si le champ est vide, afficher tous les clients
                this.filteredWarningCustomers = [...this.warningCustomers];
                return;
            }
            const searchLower = this.searchWarningTerm.toLowerCase().trim();
            this.filteredWarningCustomers = this.warningCustomers.filter(client => {
                // Recherche dans tous les champs textuels
                const searchableText = 
                `${client.name} ${client.lastVisit} ${client.objective} ${client.achieved} ${client.commercialName}`.toLowerCase();
                
                return searchableText.includes(searchLower);
            });
        }else {
            if (!this.searchSuccessTerm || this.searchSuccessTerm.trim() === '') {
                // Si le champ est vide, afficher tous les clients
                this.filteredSuccessCustomers = [...this.successCustomers];
                return;
            }
            const searchLower = this.searchSuccessTerm.toLowerCase().trim();
            this.filteredSuccessCustomers = this.successCustomers.filter(client => {
                // Recherche dans tous les champs textuels
                const searchableText = 
                `${client.name} ${client.lastVisit} ${client.objective} ${client.achieved} ${client.commercialName}`.toLowerCase();
                
                return searchableText.includes(searchLower);
            });
        }
  }
  
  onSearch(fieldSearch:any) {
    // Méthode appelée lors de la soumission du formulaire
    this.filterClients(fieldSearch);
  }
  
  // Méthode pour réinitialiser la recherche
  clearSearch() {
    this.filteredCriticalCustomers = [...this.criticalCustomers];
    this.filteredWarningCustomers = [...this.warningCustomers];
    this.filteredSuccessCustomers = [...this.successCustomers];
  }

  selectedCustomerToVisit:any=null;
  //GET Customer to plan visit 
  getCustomer(customer:any){
    this.selectedCustomerToVisit = customer;
    if(this.selectedCustomerToVisit.commercialId!=null){
        this.newVisitForm.controls["commercial"].patchValue(this.selectedCustomerToVisit.commercialId);
    }  
  }
  customizedActions:any[]=[]
  getAllCustomizedActions(){
    this.visitService.getAllCustomizedActions();
    this.visitService.customActionsSubject.subscribe(
      ( data: any ) => {
        if(data.code=="fc2057117571f77a7b4fdde71772ebcd"){
          this.customizedActions = data.actions;
          this.customizedActions = this.customizedActions.sort((a:any, b:any) => a.action_label.toLowerCase() > b.action_label.toLowerCase() ? 1 : -1);
          this.customizedActions = this.customizedActions.filter((v,i,a)=>a.findIndex(el=>(el.action_label===v.action_label))===i);
        }
      },
    )  
  }

  publicActions:any[]=[];
  getPublicActions(){
    this.visitService.getPublicActions();
    this.visitService.actionsSubject.subscribe(
      ( data: any ) => {
        if(data.code=="fc2057117571f77a7b4fdde71772ebcd"){
          this.publicActions = data.actions;
          this.publicActions = this.publicActions.sort((a:any, b:any) => a.action_label.toLowerCase() > b.action_label.toLowerCase() ? 1 : -1);
        }
      },
    )  
  }
  // ------------------------------------------------------------------------------------------
  // MF-1881 — saisie des sujets (1 à 5), en badges comme les actions.
  //
  // Cet écran ne proposait aucun sujet : addNewVisitFromGoal les ignorait côté back. Le ticket
  // les rend obligatoires ici aussi (critères d'acceptation 1 et 4), d'où ce champ.
  // ------------------------------------------------------------------------------------------

  readonly maxTopics = MAX_TOPICS;
  topics:any[]=[];
  topicsSelected:any[]=[];

  getTopics(){
    this.visitService.getTopic();
    this.visitService.topicSubject.subscribe(
      ( data: any ) => {
        if(data.code=="d9cc2e7dc2cf71242be86ab1ad241752"){
          this.topics = data.topics;
        }
      },
    )
  }

  /** Les identifiants choisis, dans l'ordre d'ajout. */
  selectedTopicUuids(): string[] {
    return this.topicsSelected.map(t => t.uuid).filter((v: any) => !!v);
  }

  selectedTopicsCount(): number {
    return this.topicsSelected.length;
  }

  /** Vrai quand la borne haute est atteinte : la liste déroulante se grise alors entièrement. */
  topicsLimitReached(): boolean {
    return this.topicsSelected.length >= MAX_TOPICS;
  }

  /** MF-1881 — ajout d'un sujet depuis la liste déroulante, en badge sous le champ. */
  addSelectedTopic(event: any): void {
    const select = event.target as HTMLSelectElement;
    const uuid = select.value;
    if (!uuid) { return; }

    if (this.topicsSelected.length >= MAX_TOPICS) {
      select.value = "";
      return;
    }

    const already = this.topicsSelected.findIndex(t => t.uuid === uuid) >= 0;
    if (!already) {
      const ref = (this.topics || []).find((t: any) => t.uuid === uuid);
      if (ref) {
        this.topicsSelected.push({ uuid: ref.uuid, topic: ref.topic });
        this.syncTopicControl();
      }
    }
    select.value = "";
  }

  /** MF-1881 — retrait d'un sujet par la croix de son badge. */
  removeSelectedTopic(topic: any): void {
    const index = this.topicsSelected.findIndex(t => t.uuid === topic.uuid);
    if (index >= 0) {
      this.topicsSelected.splice(index, 1);
      this.syncTopicControl();
    }
  }

  /** MF-1881 — vide la sélection, après un enregistrement réussi. */
  resetSelectedTopics(): void {
    this.topicsSelected = [];
    this.syncTopicControl();
  }

  /** MF-1881 — recopie la sélection dans le contrôle qui porte Validators.required. */
  private syncTopicControl(): void {
    this.newVisitForm.controls['topic_uuid'].setValue(this.selectedTopicUuids());
    this.newVisitForm.controls['topic_uuid'].markAsTouched();
    this.newVisitForm.updateValueAndValidity();
  }

  actionsSelected:any[]=[];
  action:any;
   newAction(){
    const ActionFormValue = this.newVisitForm.value;    
    if(ActionFormValue.action_description != null && ActionFormValue.action_description !=""
      && ActionFormValue.action_description !=" "){
        let index = this.actionsSelected.findIndex(d => d.action_description == ActionFormValue.action_description);      
        if(index<0){
          this.action = {
            action_description :ActionFormValue.action_description,
          };
          this.actionsSelected.push(this.action);
        }
    }
  }

  actionNotAssigned:boolean= false;
  removeSelectedAction(list:any[],value:any){
    let index;
    if(value==undefined){
      index = list.findIndex(d => d=== value); //find index in your array
      list=this.actionsSelected;
    }else {
      index = list.findIndex(d => d.action=== value); //find index in your array
      list=this.publicActions;
    }
    this.actionsSelected.splice(index, 1);//remove element from array
    
    if(this.actionsSelected.length>0){
      this.actionNotAssigned = false;
    }else {
      // if($('#datePlanned').val() != "" && $('#datePlanned').val() != null){
        setTimeout(()=>{
          $("#noActionsSelected").css({"color":"red"});
        }, 800);
        this.actionNotAssigned = true;
      // }else {
      //   this.actionNotAssigned = false;
      // }
    }
  }

    visitNotCreated:boolean=false;
    visitCreated:boolean=false;
    loadingSaveVisit:boolean=false;
    createVisit(){
        this.loadingSaveVisit = true;
        this.newVisitForm.controls["actions"].patchValue(this.actionsSelected);
        var visit= {
            customer_uuid: this.selectedCustomerToVisit.customerId,
            commercial_uuid:this.newVisitForm.value.commercial,
            // MF-1881 — les sujets étaient absents de cet écran, donc jamais envoyés.
            topics: this.selectedTopicUuids(),
            actions: this.actionsSelected
        }
        this.visitService.newGoalVisitRequest = visit;
        this.visitService.newGoalVisit();
        this.visitService.newGoalVisitSubject.subscribe(
        ( data: any ) => {
            this.loadingSaveVisit = false;
            if(data.code=="1449d22d939ee0fcd8679ce2a42546df"){
                this.newVisitForm.reset();
                this.newVisitForm.controls['action_description'].setValue("", {onlySelf: true});
                this.newVisitForm.controls['commercial'].setValue("", {onlySelf: true});
                this.resetSelectedTopics(); // MF-1881
                this.actionsSelected=[];
                this.visitCreated=true;
                this.visitNotCreated=false;
                setTimeout(()=>{
                   this.visitCreated=false;
                }, 4000);
            }else {
                this.visitCreated=false;
                this.visitNotCreated=true;
                setTimeout(()=>{
                   this.visitNotCreated=false;
                }, 5000);
            }
        },
        )
    }
    

        activeTooltipId: any = null;

        toggleTooltip(client: any) {
            this.activeTooltipId = this.activeTooltipId === client.name ? null : client.name;
        }

        @HostListener('document:click', ['$event'])
        onDocumentClick(event: Event) {
            if (!(event.target as HTMLElement).closest('.avatar-wrapper')) {
                this.activeTooltipId = null;
            }
        }
}